import { lighten } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  block: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '2rem'
  },

  blockOne: {
    '& > $header, & .taskHeaderName': {
      color: lighten('#185c7d', 0.3)
    }
  },

  blockTwo: {
    '& > $header, & .taskHeaderName': {
      color: theme.palette.primary.main
    }
  },

  noBlock: {
    marginBottom: '0',
    boxShadow: 'none',
    background: 'unset'
  },

  header: {
    marginBottom: '1rem',
    paddingLeft: '1rem',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main
  }
}))

export default useStyles
